var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import { Body } from 'syf-component-library/ui/typography';
var HelperTextContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > :not(:last-child) {\n    margin-bottom: ", "px;\n  }\n"], ["\n  & > :not(:last-child) {\n    margin-bottom: ", "px;\n  }\n"])), spacing.medium);
var Subtitle = function (_a) {
    var helperText = _a.helperText;
    var renderHelperText = function (text) {
        if (text.includes('<LIST>')) {
            var lineItems = text.split('<LIST>');
            var header = lineItems[0];
            var content = lineItems[1].split('<ITEM>').filter(Boolean);
            return (_jsxs(_Fragment, { children: [_jsx("p", { children: header }), _jsx("ul", __assign({ "data-cy": "SUPPORTING-DOCS-LIST" }, { children: content.map(function (item) {
                            return _jsx("li", { children: item });
                        }) }))] }));
        }
        if (text.includes('<BREAK>')) {
            var paragraphs = text.split('<BREAK>');
            return (_jsx(HelperTextContainer, { children: paragraphs.map(function (paragraph) { return (_jsx("p", { children: paragraph })); }) }));
        }
        return text;
    };
    return _jsx(Body, { children: renderHelperText(helperText) });
};
export default Subtitle;
var templateObject_1;
//# sourceMappingURL=index.js.map